import Image from "next/image";
import { cn } from "@/lib/utils";

const LOGOS = [
  {
    src: "/images/f45.svg",
    alt: "F45",
    className: "h-4 sm:h-5",
    // brightness-0 + invert forces the logo to pure white (plain invert tints it).
    darkClassName: "dark:opacity-90 dark:brightness-0 dark:invert",
  },
  // CycleBar sits between F45 and Alpha Fit Club so the two inverted-white logos
  // aren't adjacent in dark mode (white-on-white reads harsh).
  { src: "/images/cyclebar.png", alt: "CycleBar", className: "h-4 sm:h-5 dark:brightness-0 dark:invert" },
  { src: "/images/yogasix.png", alt: "YogaSix", className: "h-4 sm:h-5 hidden sm:block dark:hidden" },
  {
    src: "/images/alpha-fit-club.png",
    alt: "Alpha Fit Club",
    className: "h-5 sm:h-6",
    width: 193,
    height: 130,
    darkClassName: "dark:opacity-90 dark:invert",
  },
  { src: "/images/barre3.png", alt: "Barre3", className: "h-3.5 sm:h-4 dark:brightness-0 dark:invert", width: 528, height: 136 },
];

export function LogoRow({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-x-8 gap-y-4", className)}>
      {LOGOS.map((logo) => (
        <Image
          key={logo.alt}
          src={logo.src}
          alt={logo.alt}
          width={logo.width || 160}
          height={logo.height || 40}
          className={cn("w-auto shrink-0 opacity-80", logo.className, logo.darkClassName)}
        />
      ))}
    </div>
  );
}
